import axios from 'axios';
import {setAlert} from './alertAction';
import {getUserFriendsRoute} from "../../utils/apiRoutes";
import {GET_USER_CONTACTS, GET_USER_CONTACTS_FAIL, SELECT_CONTACT, SELECT_GROUP} from './typesAction';

export const getUserFriends = () => async (dispatch) => {
    try {
        const res = await axios.get(getUserFriendsRoute);

        dispatch({
            type: GET_USER_CONTACTS,
            payload: res.data,
        });
    } catch (err) {
        const errors = err.response.data.errors;

        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: GET_USER_CONTACTS_FAIL,
        });
    }
};

export const selectContact = (selectedContact) => async (dispatch) => {
    dispatch({
        type: SELECT_CONTACT,
        payload: selectedContact,
    });
};

export const selectGroup = (selectedGroup) => async (dispatch) => {
    dispatch({
        type: SELECT_GROUP,
        payload: selectedGroup,
    });
};
